import { palette } from './primitives';

// Semantic roles consumed by antd theme and feature code. Light mode only for now;
// add a `dark` sibling later without changing this shape.
export const color = {
  brand: {
    base: palette.brand[600],
    hover: palette.brand[500],
    active: palette.brand[700],
    contrast: palette.text.inverse,
  },
  status: {
    success: palette.success[700],
    successStrong: palette.success[900],
    successBg: palette.success[100],
    warning: palette.warning[700],
    warningBg: palette.warning[100],
    error: palette.error[700],
    errorStrong: palette.error[900],
    errorBg: palette.error[100],
    info: palette.info[700],
    infoBg: palette.info[100],
  },
  surface: {
    page: palette.surface.page,
    card: palette.surface.card,
    subtle: palette.surface.subtle,
    muted: palette.surface.muted,
    secondary: palette.surface.secondary,
    inverse: palette.surface.inverse,
    sunken: palette.surface.muted, // intentionally aliases muted; add palette.surface.sunken when palette expands
    tableHeader: palette.lightBrown[100], // Figma table header bg (node 173:2870)
  },
  text: {
    primary: palette.text.primary,
    secondary: palette.text.secondary,
    tertiary: palette.text.tertiary,
    muted: palette.text.muted,
    disabled: palette.text.disabled,
    inverse: palette.text.inverse,
    onBrand: palette.text.inverse, // same value as inverse — kept separate for distinct semantic intent
  },
  border: {
    subtle: palette.border.subtle,
    default: palette.border.default,
    strong: palette.border.strong,
    interactive: palette.border.interactive,
  },
} as const;
